import React from 'react';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';
import SortIcon from 'Assets/icons/sort.svg';

/**
 * `hideInactiveIcon` leaves an unsorted column without the neutral sort icon,
 * so only the active column shows an arrow. `iconClassName` colours the icon.
 */
export default function TableSortHeaderCell({ children, asc, desc, hideInactiveIcon = false, iconClassName = '' }) {
    const showIcon = asc || desc || !hideInactiveIcon;

    return (
        <div className="tw-flex tw-items-center tw-gap-x-3">
            {children}
            {showIcon && (
                <div className={`tw-shrink-0 ${iconClassName}`}>
                    {asc ? (
                        <ChevronUpIcon className="tw-w-2 tw-h-2" />
                    ) : desc ? (
                        <ChevronDownIcon className="tw-w-2 tw-h-2" />
                    ) : (
                        <SortIcon className="tw-w-3 tw-h-3" />
                    )}
                </div>
            )}
        </div>
    );
}
